import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { Help as DecisionIcon } from '@mui/icons-material';

const DecisionNode = ({ data, isConnectable, selected }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: '160px',
        minHeight: '80px'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        style={{
          background: '#D97706',
          width: 10,
          height: 10,
          border: '2px solid #fff',
          top: 10
        }}
      />
      
      {/* Diamond shape */}
      <Box
        sx={{
          width: '100%',
          height: '80px',
          background: selected 
            ? 'linear-gradient(45deg, #F59E0B 30%, #FBBF24 90%)' 
            : 'linear-gradient(45deg, #F59E0B 30%, #D97706 90%)',
          transform: 'rotate(45deg)',
          borderRadius: '8px',
          boxShadow: selected 
            ? '0 4px 20px rgba(245, 158, 11, 0.4)' 
            : '0 2px 15px rgba(245, 158, 11, 0.2)',
          border: selected ? '2px solid #D97706' : 'none',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: '0 4px 25px rgba(245, 158, 11, 0.3)',
            transform: 'rotate(45deg) scale(1.05)'
          }
        }}
      />
      
      {/* Content inside diamond */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          textAlign: 'center',
          width: '70%',
          zIndex: 1
        }}
      >
        <DecisionIcon sx={{ fontSize: 18, mb: 0.5 }} />
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600,
            fontSize: '0.75rem',
            display: 'block',
            lineHeight: 1.1
          }}
        >
          {data.label}
        </Typography>
      </Box>

      {/* Left handle for "No" */}
      <Handle
        type="source"
        position={Position.Left}
        id="no"
        isConnectable={isConnectable}
        style={{
          background: '#EF4444',
          width: 10,
          height: 10,
          border: '2px solid #fff',
          left: 5,
          top: '50%'
        }}
      />
      
      {/* Right handle for "Yes" */}
      <Handle
        type="source"
        position={Position.Right}
        id="yes"
        isConnectable={isConnectable}
        style={{
          background: '#10B981',
          width: 10,
          height: 10,
          border: '2px solid #fff',
          right: 5,
          top: '50%'
        }}
      />

      {/* Labels for Yes/No */}
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          right: -25,
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '0.6rem',
          color: '#10B981',
          fontWeight: 600
        }}
      >
        Yes
      </Typography>
      
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          left: -20,
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '0.6rem',
          color: '#EF4444',
          fontWeight: 600
        }}
      >
        No
      </Typography>
    </Box>
  );
};

export default memo(DecisionNode);